/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Block dropdown search",
  "description": "Allows you to search the options in block dropdowns.",
  "credits": [
    {
      "name": "GarboMuffin"
    }
  ],
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "userscript.css"
    }
  ],
  "tags": [
    "recommended"
  ],
  "enabledByDefault": true
};
import {isMobile} from "../../environment";
if (isMobile) manifest.enabledByDefault = false;
export default manifest;
